export default function (key = 'booking') {
  if (!sessionStorage) return {};

  return JSON.parse(sessionStorage.getItem(key));
}
